import axiosInstance from '../axios.instance';

// eslint-disable-next-line import/prefer-default-export
export const sendMessageApi = (message, token) => axiosInstance.post('/message/create/', message,
  {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

export const uploadMessageImgApi = (token, data) => axiosInstance.post('/message/upload', data, {
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${token}`,
  },
});

export const getChatPageApi = (token, params) => axiosInstance.get(`/message/messages/${params}`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const getChatsApi = (token) => axiosInstance.get('/message/chats', {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const readMessageApi = (token, chatId, messageId) => axiosInstance.get(`/message/make-read/${chatId}/${messageId}`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
